import React, { useState, useEffect } from 'react';
import { useNavigate, useOutletContext, useLocation } from 'react-router';
import Cookies from 'js-cookie';
import SearchInput from '../../../component/searchInput/SearchInput';
import { CreateWithIcon } from '../../../component/buttonComponent/ButtonComponent';
import Table from '../../../component/table/Table';
import NotificationTableEmptyState from '../../../component/tableEmptyState/NotificationTableEmptyState';
import ListNavigationTab from '../../../component/listNavigationTab/ListNavigationTab';
import Title from '../../../component/title/Title';
import SnackBar from '../../../component/snackbar/Snackbar';
import './NotificationConfiguration.css';
import HorizonLogo from './img/horizonLogo.png';
import { APIGetAlertPolicies } from '../../../config/restAPI/FetchAPI';

const defautlParams = { pageNumber: 1 }; // this to default params for fetchAPI

const NotificationConfiguration = () => {
    const [navigtionClick, setNavigtionClick, navigationState, setNavigationState, idleState, setIdleState] = useOutletContext();
    const token = Cookies.get('jwtToken');
    const agencyID = Cookies.get('agencyUUID');
    const role = Cookies.get('role');
    const navigate = useNavigate();
    const location = useLocation();
    const [triggerSnackbar, settriggerSnackbar] = useState(false); // trigger snackbar
    const [textTitleSnackbar, setTextTitleSnackbar] = useState(null);
    const [textSubSnackbar, setTextSubSnackbar] = useState(null);
    const [moduleSnackbar, setModuleSnackbar] = useState(null);
    const [searchTimeout, setSearchTimeout] = useState(null);
    const [searchText, setSearchText] = useState('');
    const [showTable, setShowTable] = useState(true);
    const [loading, setLoading] = useState(false);
    const [selectedRowCount, setSelectedRowCount] = useState(0);
    const [notificationConfigData, setNotificationConfigData] = useState([]);
    const [totalRows, setTotalRows] = useState(0);
    const [emptyState, setEmptyState] = useState(false);

    const notificationNavigationList = [
        {
            text: 'Notifications History', value: 1, path: '/notifications/history', enabled: true,
        },
        {
            text: 'Alert Configurations', value: 2, path: '/notifications/configuration', enabled: true,
        },
        {
            text: 'Export Alerts', value: 3, path: '/notifications/exportalerts', enabled: true,
        },
    ];

    const fetchAlertPolicies = async (params) => {
        try {
            const result = await APIGetAlertPolicies(setLoading, token, agencyID, params);
            const { data, totalData } = result.data;
            if (data && data.length > 0) {
                const reducer = data.map((x) => {
                    const baseData = {
                        oid: x.oid,
                        alertType: x.alertType,
                        alertName: x.name,
                        associatedTags: x.associatedTags,
                        description: x.description ? x.description : '',
                        isEnabled: x.isEnabled,
                        lastTrigger: x.lastTrigger,
                        notifiedUsers: x.notifiedUsers.length > 0 ? x.notifiedUsers.map((j) => ({
                            id: `${j.userFirstName} ${j.userLastName}`,
                            name: j.userEmail,
                            url: j.profileImageUrl ? j.profileImageUrl : null,
                            channel: j?.channels?.length > 0 ? j.channels : [],
                            oid: j.oid,
                        })) : [],
                        triggerTime: x.triggerTime && x.triggerTime.length > 0 ? x.triggerTime.map((t) => ({
                            day: t.day,
                            startTime: t.startTime,
                            endTime: t.endTime,
                        })) : [],
                    };
                    // Handle Geofence-specific data
                    if (x.alertType.trim().toLowerCase() === 'geofence') {
                        return {
                            ...baseData,
                            notification: x.geofence?.notification ? x.geofence?.notification : {
                                enter: false,
                                leave: false,
                                generatePin: false,
                            },
                            geofenceArea: (x.geofence?.geofenceArea && x.geofence?.geofenceArea.length > 0) ? x.geofence?.geofenceArea.map((i) => ({
                                oid: i?.properties?.oid,
                                name: i?.properties?.name,
                                area: [{
                                    type: i.type ? i.type : 'Feature',
                                    properties: {
                                        id: i?.properties?.oid,
                                        name: i?.properties?.name,
                                    },
                                    id: i?.properties?.oid,
                                    geometry: i?.geometry,
                                }],
                            })) : [],
                        };
                    }
                    // Handle AssetStatus-specific data
                    if (x.alertType.trim().toLowerCase() === 'asset status') {
                        return {
                            ...baseData,
                            assetStatus: {
                                motionState: x.assetStatus?.motionState || '',
                                dependentActions: {
                                    statusChange: {
                                        enabled: x.assetStatus?.dependentActions?.statusChange?.enabled || false,
                                    },
                                    greaterThan: {
                                        enabled: x.assetStatus?.dependentActions?.greaterThan?.enabled || false,
                                        timeThreshold: x.assetStatus?.dependentActions?.greaterThan?.timeThreshold || '00:00',
                                        reNotification: {
                                            enabled: x.assetStatus?.dependentActions?.greaterThan?.reNotification?.enabled || false,
                                            interval: x.assetStatus?.dependentActions?.greaterThan?.reNotification?.interval || '00:00',
                                            count: x.assetStatus?.dependentActions?.greaterThan?.reNotification?.count || 0,
                                        },
                                    },
                                    lessThan: {
                                        enabled: x.assetStatus?.dependentActions?.lessThan?.enabled || false,
                                        timeThreshold: x.assetStatus?.dependentActions?.lessThan?.timeThreshold || '00:00',
                                        reNotification: {
                                            enabled: x.assetStatus?.dependentActions?.lessThan?.reNotification?.enabled || false,
                                            interval: x.assetStatus?.dependentActions?.lessThan?.reNotification?.interval || '00:00',
                                            count: x.assetStatus?.dependentActions?.lessThan?.reNotification?.count || 0,
                                        },
                                    },
                                },
                                independentActions: {
                                    firstStatusChangeOfDay: {
                                        enabled: x.assetStatus?.independentActions?.firstStatusChangeOfDay?.enabled || false,
                                    },
                                },
                            },
                        };
                    }
                    // Handle Speeding Alert-specific data
                    if (x.alertType.trim().toLowerCase() === 'speeding') {
                        return {
                            ...baseData,
                            speeding: {
                                speedingType: x.speeding?.speedingType || 'overspeeding',
                                overspeeding: {
                                    speedLimit: x.speeding?.overspeeding?.speedLimit || 0,
                                    actions: {
                                        speedLimitBreach: {
                                            enabled: x.speeding?.overspeeding?.actions?.speedLimitBreach?.enabled || false,
                                        },
                                    },
                                },
                                underspeeding: {
                                    minSpeed: x.speeding?.underspeeding?.minSpeed || 0,
                                    maxSpeed: x.speeding?.underspeeding?.maxSpeed || 0,
                                    duration: x.speeding?.underspeeding?.duration || 0,
                                    actions: {
                                        speedRangeBreach: {
                                            enabled: x.speeding?.underspeeding?.actions?.speedRangeBreach?.enabled || false,
                                        },
                                    },
                                },
                            },
                        };
                    }
                    // Handle batteryStatus-specific data
                    if (x.alertType.trim().toLowerCase() === 'battery status') {
                        return {
                            ...baseData,
                            batteryStatus: {
                                lowBattery: {
                                    enabled: x.batteryStatus?.lowBattery?.enabled || false,
                                    threshold: x.batteryStatus?.lowBattery?.threshold || 0,
                                    reIntervalDays: {
                                        enabled: x.batteryStatus?.lowBattery?.reIntervalDays?.enabled || false,
                                        days: x.batteryStatus?.lowBattery?.reIntervalDays?.days || 0,
                                    },
                                },
                                criticalBattery: {
                                    enabled: x.batteryStatus?.criticalBattery?.enabled || false,
                                    threshold: x.batteryStatus?.criticalBattery?.threshold || 0,
                                    reIntervalDays: {
                                        enabled: x.batteryStatus?.criticalBattery?.reIntervalDays?.enabled || false,
                                        days: x.batteryStatus?.criticalBattery?.reIntervalDays?.days || 0,
                                    },
                                },
                                overVoltage: {
                                    enabled: x.batteryStatus?.overVoltage?.enabled || false,
                                    threshold: x.batteryStatus?.overVoltage?.threshold || 0,
                                    reIntervalDays: {
                                        enabled: x.batteryStatus?.overVoltage?.reIntervalDays?.enabled || false,
                                        days: x.batteryStatus?.overVoltage?.reIntervalDays?.days || 0,
                                    },
                                },
                            },
                        };
                    }
                    // Handle ev-range-specific data
                    if (x.alertType.trim().toLowerCase() === 'ev range') {
                        return {
                            ...baseData,
                            evRange: {
                                enabled: x.evRange?.enabled || false,
                                rangeThreshold: x.evRange?.rangeThreshold || 0,
                            },
                        };
                    }
                    // Handle EV-Charging-specific data
                    if (x.alertType.trim().toLowerCase() === 'ev charging') {
                        return {
                            ...baseData,
                            evCharging: {
                                start: {
                                    enabled: x.evCharging?.start?.enabled || false,
                                },
                                completed: {
                                    enabled: x.evCharging?.completed?.enabled || false,
                                    threshold: x.evCharging?.completed?.threshold || 0,
                                },
                            },
                        };
                    }
                    // Handle evBatteryTemperature-specific data
                    if (x.alertType.trim().toLowerCase() === 'ev battery temperature') {
                        return {
                            ...baseData,
                            evBatteryTemp: {
                                highTemp: {
                                    enabled: x.evBatteryTemp?.highTemp?.enabled || false,
                                    tempThreshold: x.evBatteryTemp?.highTemp?.tempThreshold || 0,
                                    reNotification: {
                                        enabled: x.evBatteryTemp?.highTemp?.reNotification?.enabled || false,
                                        minute: x.evBatteryTemp?.highTemp?.reNotification?.minute || 0,
                                    },
                                },
                                criticalTemp: {
                                    enabled: x.evBatteryTemp?.criticalTemp?.enabled || false,
                                    tempThreshold: x.evBatteryTemp?.criticalTemp?.tempThreshold || 0,
                                    reNotification: {
                                        enabled: x.evBatteryTemp?.criticalTemp?.reNotification?.enabled || false,
                                        minute: x.evBatteryTemp?.criticalTemp?.reNotification?.minute || 0,
                                    },
                                },
                            },
                        };
                    }
                    // Handle evBatteryStateOfHealth-specific data
                    if (x.alertType.trim().toLowerCase() === 'ev battery state of health') {
                        return {
                            ...baseData,
                            evBattery: {
                                stateOfHealth: {
                                    enabled: x.evBattery?.stateOfHealth?.enabled || false,
                                    percentageThreshold: x.evBattery?.stateOfHealth?.percentageThreshold || 0,
                                    reIntervalDays: {
                                        enabled: x.evBattery?.stateOfHealth?.reIntervalDays?.enabled || false,
                                        days: x.evBattery?.stateOfHealth?.reIntervalDays?.days || 0,
                                    },
                                },
                            },
                        };
                    }
                    // Default return for unknown alert types
                    return baseData;
                });

            setShowTable(true);
            setEmptyState(false);
            setNotificationConfigData(reducer);
            setLoading(false);
            setTotalRows(totalData);
            } else {
                setShowTable(false);
                setEmptyState(true);
                setLoading(false);
            }
        } catch (err) {
            setShowTable(false);
            setEmptyState(true);
            setLoading(false);
        }
    };
    // this onChange for search text
    const onChangeSearchText = (e) => {
        setSearchText(e.target.value);
    };

    // this to go to details page, (Add)
    const detailsPage = () => {
        navigate('/notifications/configuration/details', { replace: true });
    };

    // click next button in table
    const handlePageChange = (page) => {
        const pagePerNumber = {
            pageNumber: page,
        };
        fetchAlertPolicies(pagePerNumber);
    };

    useEffect(() => {
        if (location.state) {
            if (location.state.snackbarStatus) {
                let timeout;
                settriggerSnackbar(true);
                clearTimeout(timeout);
                timeout = setTimeout(() => {
                    settriggerSnackbar(false);
                }, 4000);
                setTextTitleSnackbar(location.state.snackbarTitle);
                setTextSubSnackbar(location.state.snackbarSub);
                setModuleSnackbar(location.state.snackbarStatus);
                navigate(location.pathname, { replace: true });
            }
        }
    }, [location.state]);

    useEffect(() => {
        fetchAlertPolicies();
        setNavigtionClick(2);
    }, []);

    // useEffect(() => {
    //     if (searchTimeout) {
    //         clearTimeout(searchTimeout);
    //     }

    //     setSearchTimeout(
    //         setTimeout(() => {
    //             const searchingValue = {
    //                 type: searchText,
    //                 pageNumber: 1,
    //             };
    //             fetchAlertPolicies(searchingValue);
    //         }, 200),
    //     );
    //     return () => clearTimeout(searchTimeout);
    // }, [searchText]);

    // this to render fetchGeofence once deleteGeofence
    useEffect(() => {
        if (location.state) {
            if (location.state.fetchAPICall) {
                fetchAlertPolicies(defautlParams);
                navigate(location.pathname, { replace: true }); // this to reset the state in location state
            }
            if (location.state.snackbarStatus) {
                let timeout;
                settriggerSnackbar(true);
                clearTimeout(timeout);
                timeout = setTimeout(() => {
                    settriggerSnackbar(false);
                }, 4000);
                setTextTitleSnackbar(location.state.snackbarTitle);
                setTextSubSnackbar(location.state.snackbarSub);
                setModuleSnackbar(location.state.snackbarStatus);
                navigate(location.pathname, { replace: true });
            }
        }
    }, [location.state]);

    return (
        <>
            <div className="notification-configuration-container">
                <ListNavigationTab list={notificationNavigationList} navigtionClick={navigtionClick} setNavigtionClick={setNavigtionClick} />
                <div className="notification-configuration-header">
                    <Title title="Alert Configurations" subtitle="Manage alerts that enable notifications or action triggers for devices/assets." titleSize="1.875rem" subtitleSize="1rem" lineHeight="2.375rem" subtitleLineHeight="1.5rem" />
                </div>
                <div className="notification-configuration-body">
                    <div className="notification-configuration-body-filter">
                        {/* <div className="notification-configuration-bulk-button-container">
                            <SearchInput containerWidth="25rem" text="Search" containerHeight="22px" value={searchText} onChangeText={onChangeSearchText} />
                        </div> */}
                        <div className="notification-configuration-input-filter-button">
                            <CreateWithIcon label="Create alert" module="policy" buttonHeight="44px" onClickFunction={detailsPage} />
                        </div>
                    </div>
                    {showTable && (
                        <div className={loading ? 'notification-configuration-body-text-loading' : 'notification-configuration-body-text'}>
                            <Table
                              selectedRowCount={selectedRowCount}
                              setSelectedRowCount={setSelectedRowCount}
                              tableData={notificationConfigData}
                              pagination
                              module="notification"
                              handlePageChange={handlePageChange}
                              loading={loading}
                              totalRows={totalRows}
                              backgroundColor="#F9FAFB"
                            />
                        </div>
                    )}
                    {emptyState && (
                        <div className="notification-configuration-body-empty">
                            <NotificationTableEmptyState detailsPage={detailsPage} test1="test" />
                        </div>
                    )}
                </div>
            </div>
            {
                triggerSnackbar && (
                <div className="geofence-snackbar-container">
                    <SnackBar state={triggerSnackbar} setState={settriggerSnackbar} title={textTitleSnackbar} subtitile={textSubSnackbar} module={moduleSnackbar} action={moduleSnackbar} />
                </div>
                )
            }
        </>
    );
};

export default NotificationConfiguration;
